import onDomContentLoaded from '../../utilities/onDomContentLoaded';
import '../../../scss/pages/social-media-community-guidelines/main.scss';

async function startup() {
    // TODO: Add Contentful code in the future
}

onDomContentLoaded(() => {
    startup();
});
